import { render, staticRenderFns } from "./historicoCodigosNuevo.vue?vue&type=template&id=5a63437a&scoped=true"
import script from "./historicoCodigosNuevo.vue?vue&type=script&lang=js"
export * from "./historicoCodigosNuevo.vue?vue&type=script&lang=js"
import style0 from "./historicoCodigosNuevo.vue?vue&type=style&index=0&id=5a63437a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63437a",
  null
  
)

export default component.exports